"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { ApplyButton } from "~/components/ui/apply-button-eon";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
import { SPLIT_REGEX } from "./jobad-template-eon-sverige";
export default function ContactEonSverige(t0) {
  const $ = _c(14);
  const {
    job
  } = t0;
  const t = useLanguage();
  let t1;
  if ($[0] !== job.content.task) {
    const contactTextParts = job.content.task.split(SPLIT_REGEX);
    t1 = contactTextParts.slice(1).join("");
    $[0] = job.content.task;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const contactText = t1;
  let t2;
  if ($[2] !== t.jobad_contactHL) {
    t2 = <div className="mb-8 flex w-full font-medium text-4xl lg:text-5xl"><h2 className="lg:w-96" data-source="lc">{t.jobad_contactHL}</h2></div>;
    $[2] = t.jobad_contactHL;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== contactText) {
    t3 = <div className="pb-6"><div dangerouslySetInnerHTML={{
        __html: contactText
      }} data-source="job" /></div>;
    $[4] = contactText;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex flex-col">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== job) {
    t5 = <div className="flex justify-end"><ContactImageEonSverige job={job} /></div>;
    $[9] = job;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <section className="outer-container bg-primary py-container text-lg text-white" id="contact"><div className="inner-container"><div className="grid gap-3 lg:grid-cols-2">{t4}{t5}</div></div></section>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
export function ContactImageEonSverige(t0) {
  const $ = _c(13);
  const {
    job
  } = t0;
  const t = useLanguage();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CustomImage alt="Recruiter" className="flex max-h-[250px] translate-x-10 translate-y-10 bg-white object-cover" height={250} src="images/recruiter/subclients/sverige/fallback.png" width={300} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t.sverige_contact_text) {
    t2 = <p data-source="lc">{t.sverige_contact_text}</p>;
    $[1] = t.sverige_contact_text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== job) {
    t3 = job.data.applicationUrl.length > 2 && <ApplyButton className="mt-2 rounded-[8px] px-4 font-medium text-base md:w-auto lg:px-8" job={job} variant="default" />;
    $[3] = job;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== job) {
    t4 = job.data.applicationUrlDirect && <ApplyButton className="mt-2 rounded-[8px] px-4 font-medium text-base md:w-auto lg:px-8" direct={true} job={job} variant="default" />;
    $[5] = job;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="mt-4 flex flex-col self-start">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <div className="-mt-10 flex w-72 flex-col overflow-hidden sm:w-80">{t1}<div className="!pt-16 flex flex-col gap-2 bg-white p-4 text-primary lg:max-w-96 lg:p-6">{t2}{t5}</div></div>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}